var _mask, _rect, _path, _mask2, _rect2, _mask3, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemberDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2073_9739",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3.5,
    width: 8,
    height: 5,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3.5,
    width: 8,
    height: 5,
    rx: 1,
    stroke: "#1167ED",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_2073_9739)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5V10",
    stroke: "#1167ED",
    strokeWidth: 1.5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_2073_9739",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12.5,
    width: 8,
    height: 5,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12.5,
    width: 8,
    height: 5,
    rx: 1,
    stroke: "#1167ED",
    strokeWidth: 3,
    mask: "url(#path-3-inside-2_2073_9739)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_2073_9739",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12.5,
    width: 8,
    height: 5,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12.5,
    width: 8,
    height: 5,
    rx: 1,
    stroke: "#1167ED",
    strokeWidth: 3,
    mask: "url(#path-4-inside-3_2073_9739)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5V11.5C5 10.9477 5.44772 10.5 6 10.5H14C14.5523 10.5 15 10.9477 15 11.5V12.5",
    stroke: "#1167ED",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberDepartment);
export default __webpack_public_path__ + "static/media/icon_member_department.6575102024066b634b5be5ad26240ff6.svg";
export { ForwardRef as ReactComponent };